import * as joint from '@clientio/rappid';

import { BaseGraph } from './BaseGraph';

export class JointJSGraph implements BaseGraph {
  constructor(public graph: joint.dia.Graph) {}

  getText(): string {
    return 'JointJSGraph-getText()';
  }
}
